<template>
  <el-switch
    v-model="currentValue"
    :width="options.width"
    :inactive-text="options.inactiveText"
    :active-text="options.activeText"
    :active-color="options.activeColor"
    :inactive-color="options.inactiveColor"
    @change="onChange($event, options.type)"
  >
  </el-switch>
</template>

<script>
export default {
  name: "cxSwitch",
  props: {
    value: "",
    options: {}
  },
  data() {
    return {
      currentValue: this.value
    }
  },
  methods: {
    onChange(data, type) {
      this.$emit("getSwitch", { data: data, type: type })
    }
  }
}
</script>
<!-- 先加上scoped，以后用到了再具体改样式，之前没有scoped，污染到全局的el-switch了 -->
<style scoped>
.el-switch {
  position: relative;
}
.el-switch .el-switch__label--left {
  right: 6px;
  color: rgba(0, 0, 0, 0.4);
}
.el-switch .el-switch__label--right {
  left: 8px;
  color: #fff;
}
.el-switch .el-switch__label {
  position: absolute;
  display: none;
  z-index: 2;
  margin: 0;
  font-size: 14px;
}
.el-switch .el-switch__label.is-active {
  display: block;
}
.el-switch__core {
  border: 1px solid #e9e9e9 !important;
  height: 24px;
  border-radius: 31px;
}

.el-switch__core:after {
  background-color: rgba(0, 0, 0, 0.2);
  top: 3px;
  left: 3px;
}
.el-switch.is-checked .el-switch__core::after {
  background-color: #fff;
}
</style>
